var _defs, _path, _g, _path2, _path3, _path4, _line, _line2, _path5, _line3, _line4, _path6, _path7, _path8, _path9, _path10, _line5, _line6, _line7, _line8, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _line9, _path18, _path19, _path20, _path21, _path22, _path23, _line10, _path24, _polygon, _path25, _polygon2, _path26, _path27, _polygon3, _path28, _polygon4, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _ellipse, _ellipse2, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _g2, _path48, _path49, _path50, _path51, _circle, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _circle2, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _line11, _line12, _line13, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _ellipse3, _ellipse4, _path125, _path126, _path127, _g3, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _circle3, _ellipse5, _path147, _path148, _path149, _path150, _ellipse6, _path151;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeamwork(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "illustration",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1024 768",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-16,.cls-20,.cls-21,.cls-22,.cls-26,.cls-27,.cls-4,.cls-9{fill:none;}.cls-2{fill:#eaf9f3;}.cls-3{clip-path:url(#clip-path);}.cls-4{stroke:#b8d8c7;}.cls-16,.cls-20,.cls-21,.cls-22,.cls-26,.cls-27,.cls-4,.cls-9{stroke-linecap:round;stroke-linejoin:round;stroke-width:1.8px;}.cls-5{fill:#b8d8c7;}.cls-6{fill:#f8ab5d;}.cls-7{fill:#ffe779;}.cls-8{fill:#22272e;}.cls-9{stroke:#63737a;}.cls-10{fill:#63737a;}.cls-11{fill:#b0d7c0;}.cls-12{fill:#f4c2c9;}.cls-13{fill:#6dafa7;}.cls-14{fill:#e26e85;}.cls-15{fill:#fff;}.cls-16{stroke:#e26e85;}.cls-17{clip-path:url(#clip-path-2);}.cls-18{fill:#e3d7ff;}.cls-19{fill:#e86484;}.cls-20{stroke:#22272e;}.cls-21{stroke:#f8ab5d;}.cls-22{stroke:#6dafa7;}.cls-23{fill:#b28d93;}.cls-24{fill:#896068;}.cls-25{clip-path:url(#clip-path-3);}.cls-26{stroke:#89555f;}.cls-27{stroke:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M766.3,538.9,246.3,524a48.07,48.07,0,0,1-46.5-43.3l-25.1-248a48.18,48.18,0,0,1,47.2-53l578.8-8a48.21,48.21,0,0,1,48.5,54.1L815.5,496.7A48.27,48.27,0,0,1,766.3,538.9Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M717.5,240.4s5.8-7.9,34.4-9.9,45.5,4.3,51.5,14.2-10.3,65.4-11.8,73.1,6.1,27,6.1,31.1-32.8,16.2-53.5,15.8a103.54,103.54,0,0,1-39.5-8.9,4.24,4.24,0,0,1-2.4-4.7c1.2-6,3.8-19.7,6.3-31.6C711.9,303.6,702.8,264.1,717.5,240.4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M186.4,374.7a2.91,2.91,0,0,1-1.6-3.8c3.1-8.8,13.8-37.5,22.8-47.5,10.8-11.9,44.9-12.6,59.4-12.6s34.9,2.6,43,9.6c7,6,18.6,35.8,21.8,44.2a3.13,3.13,0,0,1-1.1,3.6c-4,2.7-13.5,8.8-22.5,12.1l4.3,60.6s-93.4-1.4-97.1-3.2-8.5-23.7-7.8-26,7.4-27.8,7.4-27.8S196.2,379,186.4,374.7Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M766.3,538.9,246.3,524a48.07,48.07,0,0,1-46.5-43.3l-25.1-248a48.18,48.18,0,0,1,47.2-53l578.8-8a48.21,48.21,0,0,1,48.5,54.1L815.5,496.7A48.27,48.27,0,0,1,766.3,538.9Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M597.3,606.2H181.8a15,15,0,0,1-15-15V355.5a15,15,0,0,1,15-15H597.3a15,15,0,0,1,15,15V591.1A15.07,15.07,0,0,1,597.3,606.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M903,590.3H779a15,15,0,0,1-15-15V231a15,15,0,0,1,15-15H903a15,15,0,0,1,15,15V575.3A15,15,0,0,1,903,590.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M259.9,270.1H170v-8.9h89.9a1.79,1.79,0,0,1,1.8,1.8v5.2A1.71,1.71,0,0,1,259.9,270.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M243.7,261.3H223.4a4.32,4.32,0,0,1-4.3-3.8l-1.6-14.4a4.33,4.33,0,0,1,4.3-4.8h23.5a4.34,4.34,0,0,1,4.3,4.8L248,257.5A4.41,4.41,0,0,1,243.7,261.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M231.1,238.3s-8-.8-9.6-11.6c0,0,7.2,2.1,9.5,7.2,0,0,1-11.4,6.4-12.5,0,0,2.4,8.5-1.4,12.7,0,0,2.9-4.8,10.3-4.7a13.6,13.6,0,0,1-9.2,8.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M594.2,390.2H504a4.23,4.23,0,0,1-4.2-4.2V358.6a4.23,4.23,0,0,1,4.2-4.2h90.2a4.23,4.23,0,0,1,4.2,4.2V386A4.23,4.23,0,0,1,594.2,390.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M559.4,364.1H538.6a1.54,1.54,0,0,1-1.5-1.5h0a1.54,1.54,0,0,1,1.5-1.5h20.8a1.54,1.54,0,0,1,1.5,1.5h0A1.47,1.47,0,0,1,559.4,364.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M594.2,436H504a4.23,4.23,0,0,1-4.2-4.2V404.4a4.23,4.23,0,0,1,4.2-4.2h90.2a4.23,4.23,0,0,1,4.2,4.2v27.4A4.23,4.23,0,0,1,594.2,436Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M559.4,409.9H538.6a1.54,1.54,0,0,1-1.5-1.5h0a1.54,1.54,0,0,1,1.5-1.5h20.8a1.54,1.54,0,0,1,1.5,1.5h0A1.47,1.47,0,0,1,559.4,409.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M241.4,390.2H151.2A4.23,4.23,0,0,1,147,386V358.6a4.23,4.23,0,0,1,4.2-4.2h90.2a4.23,4.23,0,0,1,4.2,4.2V386A4.1,4.1,0,0,1,241.4,390.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M206.7,364.1H185.9a1.54,1.54,0,0,1-1.5-1.5h0a1.54,1.54,0,0,1,1.5-1.5h20.8a1.54,1.54,0,0,1,1.5,1.5h0A1.54,1.54,0,0,1,206.7,364.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M241.4,436H151.2a4.23,4.23,0,0,1-4.2-4.2V404.4a4.23,4.23,0,0,1,4.2-4.2h90.2a4.23,4.23,0,0,1,4.2,4.2v27.4A4.1,4.1,0,0,1,241.4,436Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M206.7,409.9H185.9a1.54,1.54,0,0,1-1.5-1.5h0a1.54,1.54,0,0,1,1.5-1.5h20.8a1.54,1.54,0,0,1,1.5,1.5h0A1.54,1.54,0,0,1,206.7,409.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M945.2,320.9H785.4a4.65,4.65,0,0,1-4.6-4.6V236.6a4.65,4.65,0,0,1,4.6-4.6H945.3a4.65,4.65,0,0,1,4.6,4.6v79.7A4.74,4.74,0,0,1,945.2,320.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M945.2,419.8H785.4a4.65,4.65,0,0,1-4.6-4.6V335.5a4.65,4.65,0,0,1,4.6-4.6H945.3a4.65,4.65,0,0,1,4.6,4.6v79.7A4.67,4.67,0,0,1,945.2,419.8Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 811.4,
    y: 270.6,
    width: 9.9,
    height: 50.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 821.3,
    y: 284.3,
    width: 10.3,
    height: 36.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M815.2,376.1l1.1-14.9a1.65,1.65,0,0,0-1.7-1.8H806a1.71,1.71,0,0,0-1.7,1.8l1.1,14.9s-9,5.8-8.9,10.6c.1,3.7,2.3,21.4,3.3,29.2a4.32,4.32,0,0,0,4.3,3.8h12.4a4.32,4.32,0,0,0,4.3-3.8c1-7.8,3.2-25.5,3.3-29.2C824.2,381.9,815.2,376.1,815.2,376.1Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 190.9,
    y1: 514.2,
    x2: 835.1,
    y2: 514.2
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M476.1,199.4l-93.7,12a8.19,8.19,0,0,1-8.8-7.2l-9.9-87.8c-.5-4.1,2.8-7.2,7-6.7l93.8,12a8.5,8.5,0,0,1,7.1,6.8l9.7,63.8A6.05,6.05,0,0,1,476.1,199.4Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M479.9,199.4l-93.7,12a8.35,8.35,0,0,1-8.9-7.2l-10-87.8c-.5-4.1,2.8-7.2,7-6.7l93.8,12a8.5,8.5,0,0,1,7.1,6.8l9.8,63.8A5.88,5.88,0,0,1,479.9,199.4Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M408,142.3c3-1.1,4.2-5.4.9-9.8-5-4.1-9.7-1.1-9.1,3.7a7.75,7.75,0,0,0,4.4,5.9,9.45,9.45,0,0,0-7.9,8.2l21.1.6A13.91,13.91,0,0,0,408,142.3Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 427.3,
    y1: 135.9,
    x2: 461.7,
    y2: 138.4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 428.4,
    y1: 144.1,
    x2: 462.8,
    y2: 145.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M412.8,179.6c3-1.5,4.2-6.1.8-10.3-5-3.8-9.7-.1-9.1,4.8a6.91,6.91,0,0,0,4.5,5.7c-4.1,1-7.2,4.7-7.9,9.4l21.1-1.6C420.6,183.3,416.9,180.1,412.8,179.6Z"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 432.1,
    y1: 170.8,
    x2: 466.3,
    y2: 169.9
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 433.2,
    y1: 179.3,
    x2: 467.5,
    y2: 177.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M565.9,274.4l-44.8-7.9c-5.1-.9-8.8-6.8-8.3-13.2l8.3-104.6c.5-6.4,5.1-12.3,10.3-13.2l46-7.9c6.8-1.2,12,4,11.4,11.6L579,263C578.6,270.4,572.6,275.5,565.9,274.4Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M562.4,274.4l-44.8-7.9c-5.1-.9-8.8-6.8-8.3-13.2l8.3-104.6c.5-6.4,5.1-12.3,10.3-13.2l46-7.9c6.8-1.2,12,4,11.4,11.6L575.5,263C575.1,270.4,569,275.5,562.4,274.4Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M548.9,143.3l-8.6,1.2a1.33,1.33,0,0,1-1.4-1.6h0a2.15,2.15,0,0,1,1.7-2l8.6-1.3c.9-.1,1.5.6,1.5,1.6h0A2.26,2.26,0,0,1,548.9,143.3Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M557.6,142.1l-1.2.2a1.36,1.36,0,0,1-1.5-1.6h0a2.36,2.36,0,0,1,1.8-2.1l1.2-.2a1.36,1.36,0,0,1,1.5,1.6h0A2.34,2.34,0,0,1,557.6,142.1Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M534.1,254.4l-14.9-2.1c-1.6-.2-2.8-2-2.6-4h0c.2-2,1.6-3.5,3.2-3.3l14.9,1.8c1.7.2,3,2.1,2.9,4.2h0C537.4,253.2,535.8,254.7,534.1,254.4Z"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 523.7,
    y1: 158.8,
    x2: 545,
    y2: 156.4
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 520.1,
    y1: 203.6,
    x2: 530.4,
    y2: 203.7
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 538.4,
    y1: 203.7,
    x2: 549.7,
    y2: 203.8
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 558.6,
    y1: 203.9,
    x2: 571.1,
    y2: 204
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M548.3,195.7l-24.9.3c-1.5,0-2.6-1.5-2.4-3.3l1.7-21.6a3.87,3.87,0,0,1,3-3.6l25.1-2.2c1.7-.2,3,1.3,2.8,3.3L551.8,192A4.15,4.15,0,0,1,548.3,195.7Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M581,195.2l-16.7.2a3.12,3.12,0,0,1-3-3.6l1.9-24a4.48,4.48,0,0,1,3.6-4l16.8-1.5Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M564.8,240.5l-44.6-4.2c-1.5-.1-2.5-1.7-2.4-3.6l1.4-17.7c.1-1.8,1.5-3.3,2.9-3.3L567,213a3.4,3.4,0,0,1,3.1,3.9l-1.6,20.2A3.49,3.49,0,0,1,564.8,240.5Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M644.7,275.9l-44.6-9.2c-5-1-8.5-7-8-13.4l8.3-104.6c.5-6.4,5-12.4,10.2-13.4l46.1-9.2c7-1.4,12.3,3.7,11.7,11.5l-10,126.9C657.6,272.2,651.4,277.3,644.7,275.9Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M641.9,275.9l-44.6-9.2c-5-1-8.5-7-8-13.4l8.3-104.6c.5-6.4,5-12.4,10.2-13.4l46.1-9.2c7-1.4,12.3,3.7,11.7,11.5l-10,126.9C654.8,272.2,648.6,277.3,641.9,275.9Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M628.4,142.7l-8.6,1.4c-.8.1-1.4-.6-1.4-1.6h0a2.37,2.37,0,0,1,1.7-2.1l8.6-1.5c.9-.2,1.5.6,1.5,1.6h0A2.76,2.76,0,0,1,628.4,142.7Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M637.1,141.2l-1.2.2c-.9.2-1.6-.6-1.5-1.6h0a2.48,2.48,0,0,1,1.8-2.2l1.2-.2c.9-.2,1.6.6,1.5,1.6h0A2.46,2.46,0,0,1,637.1,141.2Z"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 603.4,
    y1: 158.7,
    x2: 624.5,
    y2: 156
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M613.5,254.9l-14.7-2.4c-1.6-.3-2.7-2.1-2.5-4.1h0c.2-2,1.5-3.5,3.1-3.2l14.7,2c1.7.2,3,2.2,2.8,4.3h0C616.8,253.7,615.2,255.2,613.5,254.9Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M648,195.3l-45,.7c-1.5,0-2.5-1.5-2.4-3.3l1.7-21.7c.1-1.8,1.4-3.5,2.9-3.6l45.3-4.7a3,3,0,0,1,3.2,3.5l-2,25.1A4,4,0,0,1,648,195.3Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M629.1,179.3l-4.6-3c-.6-.4-1.5.2-1.5,1.1l-.5,6.5a.88.88,0,0,0,1.4.9l5.1-3.5A1.22,1.22,0,0,0,629.1,179.3Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M644.7,236.6l-44.5-4.4c-1.4-.1-2.5-1.7-2.3-3.6l1.7-21.7c.1-1.8,1.4-3.3,2.9-3.3l44.9.4a3.48,3.48,0,0,1,3.2,3.9l-2,25.1C648.3,235.2,646.6,236.8,644.7,236.6Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M626,218.4l-4.5-3.5c-.6-.5-1.5.1-1.5,1l-.5,6.5c-.1.9.7,1.5,1.4,1.1l5-3A1.32,1.32,0,0,0,626,218.4Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M433.5,205.3h0a3.69,3.69,0,0,0,3.7,3.7h75.6"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 583.6,
    y1: 209,
    x2: 592.9,
    y2: 209
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M347.3,486.5H200a4.44,4.44,0,0,1-4.4-4.4h0a4.44,4.44,0,0,1,4.4-4.4H347.3a4.44,4.44,0,0,1,4.4,4.4h0A4.44,4.44,0,0,1,347.3,486.5Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "218.8 486.5 208 486.5 207 499.3 217.5 499.3 218.8 486.5"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M207,499.3,195.4,653.4a3.24,3.24,0,0,0,3.2,3.5,3.17,3.17,0,0,0,3.2-2.9l15.7-154.6H207Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "328.5 486.5 339.4 486.5 340.3 499.3 329.8 499.3 328.5 486.5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M340.3,499.3,352,653.4a3.24,3.24,0,0,1-3.2,3.5,3.17,3.17,0,0,1-3.2-2.9L329.9,499.4h10.4Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M503.7,486.5H356.4a4.44,4.44,0,0,1-4.4-4.4h0a4.44,4.44,0,0,1,4.4-4.4H503.7a4.44,4.44,0,0,1,4.4,4.4h0A4.37,4.37,0,0,1,503.7,486.5Z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "375.3 486.5 364.4 486.5 363.4 499.3 374 499.3 375.3 486.5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M363.4,499.3,351.8,653.4a3.24,3.24,0,0,0,3.2,3.5,3.17,3.17,0,0,0,3.2-2.9L374,499.3Z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "484.9 486.5 495.8 486.5 496.8 499.3 486.2 499.3 484.9 486.5"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M496.8,499.3l11.6,154.1a3.24,3.24,0,0,1-3.2,3.5A3.17,3.17,0,0,1,502,654L486.3,499.4h10.5Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M743.5,603.4l1.9,18.5c.4,3.4,1.1,7.6,1.6,10.3a5.73,5.73,0,0,1-1.5,5h0a51.27,51.27,0,0,0,0,10.3v.2a6.13,6.13,0,0,1-5.2,6.8,174.59,174.59,0,0,1-22.1,2.2,92,92,0,0,1-14.9-.6,5.09,5.09,0,0,1-3.5-8.1c4.2-5.5,9.9-13.3,13.1-18,5.3-8,4.6-18.8,3.4-26.7S739.1,597.4,743.5,603.4Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M744.2,610.3c-.4-3.8-.7-6.9-.7-6.9-4.3-6-28.4-7.9-27.2,0a63.15,63.15,0,0,1,.7,14C727.1,619.1,738.6,617.7,744.2,610.3Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M745.5,647.7a51,51,0,0,1,0-10.3h0a5.82,5.82,0,0,0,1.5-5c-.5-2.7-1.2-6.9-1.6-10.3a.9.9,0,0,0-.1-.5c-3.1,2.9-6.4,5.6-7.7,9.7a4.44,4.44,0,0,1-5.3,3c-7.4-1.9-14.8-2.3-22.2.1-3.1,4.4-7.2,9.8-10.3,14a5.07,5.07,0,0,0,3.5,8.1,121.7,121.7,0,0,0,14.9.6,174.59,174.59,0,0,0,22.1-2.2,6.13,6.13,0,0,0,5.2-6.8Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M798.3,605.4s3.1,11.8,3.1,15.9c0,2.9-.7,10-1.2,14.2a8,8,0,0,0,.9,4.8,1.69,1.69,0,0,1,.3,1c.1.7.1,3.7.1,6.5a6.2,6.2,0,0,0,5.6,6.2,154.21,154.21,0,0,0,17.9.2c6.9-.2,11.6-.6,14.7-.9a4.6,4.6,0,0,0,3.6-6.7c-4.2-7.8-11.5-21.8-13-25.2-2.1-4.9-4.3-19.1-4.3-19.1S798.9,591.2,798.3,605.4Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M828.4,614.8c-1.3-5.8-2.4-12.5-2.4-12.5s-27.1-11.1-27.6,3.1c0,0,.7,2.6,1.4,5.8C809.3,614.9,818.8,615.6,828.4,614.8Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M843.3,646.6c-1.8-3.3-4.1-7.8-6.4-12.1a4.87,4.87,0,0,0-1.2-.1c-7.9-2.2-16.8,1.1-24.7,1.1-3.1-1-4.3-9.6-9.7-12.7-.2,3.4-.7,9.2-1.1,12.8a8,8,0,0,0,.9,4.8,1.69,1.69,0,0,1,.3,1c.1.7.1,3.7.1,6.5a6.2,6.2,0,0,0,5.6,6.2,154.21,154.21,0,0,0,17.9.2c6.9-.2,11.6-.6,14.7-.9A4.66,4.66,0,0,0,843.3,646.6Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M794.8,343.3s8.1,12.5,10.3,37.1c1.3,14.2-.5,63.7,0,68.4.4,3.6,7,48.3,13.1,89.3,3,19.6,8.4,39.2,11.5,51.9a20.39,20.39,0,0,1-1.3,14.2s-2,6.5-11.5,7c-11.1.5-14.9-.9-20.1-3.1a13.75,13.75,0,0,1-7.9-9.9c-2-11-4.6-31.3-10.8-52.9-7.8-27-17.7-58.4-21.6-82.8-.5-2.9-2.6-12.5-4.8-21.6-1.9-7.7-3.8-15-4.8-17.8-3.6-10-3.2-10.4-4.4-12.8-1.9-3.8-6.3.9-10.7-17.3a79.78,79.78,0,0,1-1.6-11.4c-1-11.5-1.3-25.6-1.3-25.6S779.4,331,794.8,343.3Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M703.8,355.1a702.2,702.2,0,0,0-6.9,99.5c0,11.3,2.9,37.7,6.3,65.3,3.6,29.5,4.2,53.5,6.2,77.1a13.73,13.73,0,0,0,3.7,8.4c1,1,1.9,2.1,2.9,3.1,1.6,1.8,5.3,4.5,12.9,4.3,11.3-.3,16.6-5.8,18.7-8.5,1.7-2.2,3.8-4.8,3.9-11.7.3-16.8-3.8-22.4-2.5-76.9a466.45,466.45,0,0,0-1.7-53.3c-.6-6.2,20.9-76.6,22.8-85.7S719.6,346,703.8,355.1Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M783.9,368s1.9,14.9,15.2,22.4"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M751.5,440.9c-1.9-7.7-3.8-15-4.8-17.8-3.6-10-3.2-10.4-4.4-12.8-1.9-3.8-6.3.9-10.7-17.3"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 712.4,
    cy: 467.8,
    rx: 12.8,
    ry: 14
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 782.3,
    cy: 467.8,
    rx: 13.9,
    ry: 14
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M719.1,301.4c-12.8,17.3-26.3,25.1-37.8,17.7-9.9-6.4-20-53.6-23.3-70.1-.7-3.6-1.1-5.7-1.1-5.7l-1.1-4.9s-10.6-1.7-13.2-2.5a12,12,0,0,1-7.6-6.1c-2.1-3.8-7.8-10.2-5.1-11.1s9.9,7.9,9.9,7.9a113,113,0,0,0,15.9-1c9.6-1.2,14.5-1.2,17.5,2.8a20.43,20.43,0,0,1,2.7,6.1l2.2,5.9,15,39.9s.7-1.3,1.8-3.4C705.6,283,712.6,292,719.1,301.4Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M713.8,308a72.75,72.75,0,0,0,5.3-6.6c-6.5-9.3-13.6-18.4-24.3-24.5-.4.8-.7,1.4-1,1.9C702.6,287.1,709,297.1,713.8,308Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M693.1,276.4c10.7,6.2,19.6,15.7,26.1,25,1.5-2.1,3.1-4.3,4.6-6.6A198.79,198.79,0,0,0,696,271.9,27.83,27.83,0,0,0,693.1,276.4Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M717.5,240.8s-6,4.6-12.6,17a150.08,150.08,0,0,1-9,14,206.06,206.06,0,0,1,27.8,22.9c1.8-2.8,3.6-5.8,5.4-8.9C744.7,258,727,235.7,717.5,240.8Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M693.1,280.3s2.1,5.8,3.9,11"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M634.1,228.3s-4.9-3.7-7.5-5.4,1.7-3.6,5.6-2,10.7,3.9,10.7,3.9-4.2-4-5.3-5.4,1.7-2.6,4.4-.9,7.3,5.9,10.5,7.3,3.1,5,1.5,5.6S640.2,230.7,634.1,228.3Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M670.1,225.9s-5.4-2.7-7.6-3.6a39.82,39.82,0,0,0-6.7-2.1c-.9-.1-2.6,1.6.7,4.3s5.2,4.3,5.2,4.3S671.7,229.2,670.1,225.9Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M717.5,240.4s5.8-7.9,34.4-9.9,45.5,4.3,51.5,14.2-10.3,65.4-11.8,73.1,6.1,27,6.1,31.1-32.8,16.2-53.5,15.8a103.54,103.54,0,0,1-39.5-8.9,4.24,4.24,0,0,1-2.4-4.7c1.2-6,3.8-19.7,6.3-31.6C711.9,303.6,702.8,264.1,717.5,240.4Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M701.5,371.4l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1.1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.42,2.42,0,0,1,701.5,371.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M703.9,351.1l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.32,2.32,0,0,1,703.9,351.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M706.3,330.9l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1.1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.25,2.25,0,0,1,706.3,330.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M708.7,310.6l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1.1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.25,2.25,0,0,1,708.7,310.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M711.1,290.3l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1.1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.35,2.35,0,0,1,711.1,290.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M719.8,373.6l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1.1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.25,2.25,0,0,1,719.8,373.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M722.2,353.3l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1.1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.35,2.35,0,0,1,722.2,353.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M724.6,333l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1.1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.35,2.35,0,0,1,724.6,333Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M726.9,312.7l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1.1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.42,2.42,0,0,1,726.9,312.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M729.3,292.4l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1.1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.44,2.44,0,0,1,729.3,292.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M738.1,375.7l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1.1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.35,2.35,0,0,1,738.1,375.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M740.5,355.4l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1.1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.45,2.45,0,0,1,740.5,355.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M742.8,335.2l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1.1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.23,2.23,0,0,1,742.8,335.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M745.2,314.9l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1.1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.25,2.25,0,0,1,745.2,314.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M747.6,294.6l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1.1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.25,2.25,0,0,1,747.6,294.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M756.3,377.9l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1.1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.23,2.23,0,0,1,756.3,377.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M758.7,357.6l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1.1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.25,2.25,0,0,1,758.7,357.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M761.1,337.3l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1.1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.35,2.35,0,0,1,761.1,337.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M763.5,317l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1.1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.35,2.35,0,0,1,763.5,317Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M765.9,296.7l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1.1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.45,2.45,0,0,1,765.9,296.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M774.6,380l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1.1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.35,2.35,0,0,1,774.6,380Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M777,359.7l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1.1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.35,2.35,0,0,1,777,359.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M779.4,339.4l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1.1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.45,2.45,0,0,1,779.4,339.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M781.7,319.2l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1.1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.23,2.23,0,0,1,781.7,319.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M784.1,298.9l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1.1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.24,2.24,0,0,1,784.1,298.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M792.9,382.1l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.33,2.33,0,0,1,792.9,382.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M795.2,361.9l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1.1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.23,2.23,0,0,1,795.2,361.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M797.6,341.6l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1.1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.24,2.24,0,0,1,797.6,341.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M800,321.3l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1.1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.35,2.35,0,0,1,800,321.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M802.4,301l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1.1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.35,2.35,0,0,1,802.4,301Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M811.1,384.3l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1.1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.24,2.24,0,0,1,811.1,384.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M813.5,364l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1.1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.35,2.35,0,0,1,813.5,364Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M815.9,343.7l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1.1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.45,2.45,0,0,1,815.9,343.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M818.3,323.4l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1.1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.45,2.45,0,0,1,818.3,323.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M820.6,303.2l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1.1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.23,2.23,0,0,1,820.6,303.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M713.4,270l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1.1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.32,2.32,0,0,1,713.4,270Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M715.8,249.7l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1.1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.44,2.44,0,0,1,715.8,249.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M718.2,229.5l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1.1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.25,2.25,0,0,1,718.2,229.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M720.6,209.2l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1.1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.25,2.25,0,0,1,720.6,209.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M731.7,272.2l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1.1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.25,2.25,0,0,1,731.7,272.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M734.1,251.9l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1.1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.25,2.25,0,0,1,734.1,251.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M736.5,231.6l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1.1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.35,2.35,0,0,1,736.5,231.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M738.8,211.3l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1.1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.32,2.32,0,0,1,738.8,211.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M750,274.3l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1.1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.35,2.35,0,0,1,750,274.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M752.4,254l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1.1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.35,2.35,0,0,1,752.4,254Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M754.7,233.7l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1.1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.42,2.42,0,0,1,754.7,233.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M757.1,213.5l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1.1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.25,2.25,0,0,1,757.1,213.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M768.2,276.4l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1.1-1.4a2.25,2.25,0,0,1,.4-3.2L765,276A2.42,2.42,0,0,1,768.2,276.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M770.6,256.2l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1.1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.25,2.25,0,0,1,770.6,256.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M773,235.9l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1.1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.25,2.25,0,0,1,773,235.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M775.4,215.6l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1.1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.35,2.35,0,0,1,775.4,215.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M786.5,278.6l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1.1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.35,2.35,0,0,1,786.5,278.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M788.9,258.3l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1.1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.35,2.35,0,0,1,788.9,258.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M791.3,238l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1.1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.45,2.45,0,0,1,791.3,238Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M793.6,217.7l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1.1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.42,2.42,0,0,1,793.6,217.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M804.8,280.7l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1.1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.45,2.45,0,0,1,804.8,280.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M807.1,260.5l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1.1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.23,2.23,0,0,1,807.1,260.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M809.5,240.2l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1.1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.24,2.24,0,0,1,809.5,240.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M811.9,219.9l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1.1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.25,2.25,0,0,1,811.9,219.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M823,282.9l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1.1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.24,2.24,0,0,1,823,282.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M825.4,262.6l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1.1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.35,2.35,0,0,1,825.4,262.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M827.8,242.3l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1.1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.35,2.35,0,0,1,827.8,242.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M830.2,222l1.1,1.4a2.25,2.25,0,0,1-.4,3.2l-1.4,1.1a2.25,2.25,0,0,1-3.2-.4l-1.1-1.4a2.25,2.25,0,0,1,.4-3.2l1.4-1.1A2.45,2.45,0,0,1,830.2,222Z"
  }))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M771.7,236.8c-.1,7-12.1,19.3-22.3,20.3-10.2,1.9-15.6-7.6-15.6-15.5s8.9-15.4,19.3-16.4C762.9,224.1,771.8,229.7,771.7,236.8Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M740.2,221.6l-1.5,12.8s-3.6,11.4,7.7,12.8,19-9.6,19.4-13.4l-1.5-28.7C764.4,205.2,744,207.1,740.2,221.6Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M754.1,228.1c-4.6,1.4-9.8,1.2-14.8,1.1l-.5,4.5A19.26,19.26,0,0,0,754.1,228.1Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M739.1,339.1H686.4a4.84,4.84,0,0,1-4.8-4.1l-5.7-36.3a3.79,3.79,0,0,1,3.8-4.4h52.7a4.84,4.84,0,0,1,4.8,4.1l5.7,36.3A3.79,3.79,0,0,1,739.1,339.1Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 706.1,
    cy: 300.9,
    r: 1.6
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M750.8,316.8s-4-4.5-6.4-6a31.57,31.57,0,0,0-5.7-2.6l-.1,8.5S748.3,318.3,750.8,316.8Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M756.3,316.2c-3.4.4-5.5.6-5.5.6a38.92,38.92,0,0,0-4.7-3.1c-2.4-1.3-7-.7-11.2-.9s-8.8-.4-13.5-.8c-3.6-.3-6.9-.7-7.3.8-.6,2.4,4.8,3,4.8,3s-5.1,0-6.3.6c-2.5,1.2-.2,3.2-.2,3.2-3.6,1.7-.3,4.3-.3,4.3s-1.9.8-.5,3c2.9,4.7,17.6,9,20.9,9h14.8s3.8.3,10.2.9A31.09,31.09,0,0,0,756.3,316.2Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M764,315.4c-2.9.3-5.5.6-7.6.8a31.07,31.07,0,0,1,1.1,20.6c2.1.2,4.5.4,7.1.6C767.1,330.2,767.7,322.6,764,315.4Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M789.8,294.5c4,9.1,7.8,17.2,7.8,17.2-3.6.5-21.1,2.4-33.7,3.7,3.7,7.3,3.1,14.8.6,22.1,7.1.6,15.9,1.4,25.6,2.3,24.2,2.2,39.7.9,43.1-12.1,2.9-11.1-.7-21.6-12.4-48.9C810.2,283.4,799.4,288,789.8,294.5Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M820.9,278.8c-10.7,4.6-21.5,9.2-31.1,15.7.3.6.6,1.3.9,1.9,9.3-8,21.1-9.9,33-11.1C822.8,283.2,821.9,281.1,820.9,278.8Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M821.7,271.1c-14.1-32.5-23.4-32-23.4-32-16.6-6.1-23.2,16.5-17.1,35,1.2,3.8,4,9.7,6.7,15.8,9.6-7.8,23-12.8,34.9-16.4A12.81,12.81,0,0,1,821.7,271.1Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M787.8,289.9c.7,1.5,1.4,3.1,2,4.6,9.5-6.5,24.1-11.9,34.8-16.5-.6-1.5-1.3-3-2-4.6C810.8,277.1,797.3,282,787.8,289.9Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M719,315.8s6.6.9,8.6,1.3a60.35,60.35,0,0,0,6.3.6"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M712.4,319.6s7.1,1.7,9.8,2.3,10.9,1.5,10.9,1.5"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M712.1,323.9a53.78,53.78,0,0,0,8,3.5,79.63,79.63,0,0,0,11.4,2.4"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M797.6,311.6s12-1.9,14.9-1.7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 762.2,
    cy: 323.5,
    r: 5.2
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M727.1,180.5a12.69,12.69,0,0,0-3.3,11.8c1.5,7.6,12.2,14.9,12.2,14.9S740.7,173.6,727.1,180.5Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M728.1,183.6s-1.3,19.2-1.6,26.8,2.7,17.9,13.8,19.7,22.4-3.5,26.1-17.9,3.3-30.9-9.3-33.1S728.1,183.6,728.1,183.6Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M762.7,206.4a10.77,10.77,0,0,0-2.4-7.2,12.14,12.14,0,0,1-2.4-7.8s-2.1-10.8-17.8-.5c-6.6,4.3-22.1-1.3-19.3-13.5,4.3-18.8,27.9-10.8,34.7-9.6S769,169,770.2,176c0,0,10.6,4.5,7.5,16.9-4.1,16.2-12.3,33-12.3,33S764.5,216.7,762.7,206.4Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M761.1,206.3s2.3-7.7,8.4-6,3.1,13.6-5.3,15.1"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M730.3,204h0a1.32,1.32,0,0,1-1.3-1.3v-1.2a1.32,1.32,0,0,1,1.3-1.3h0a1.32,1.32,0,0,1,1.3,1.3v1.2A1.21,1.21,0,0,1,730.3,204Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M745.5,204h0a1.32,1.32,0,0,1-1.3-1.3v-1.2a1.32,1.32,0,0,1,1.3-1.3h0a1.32,1.32,0,0,1,1.3,1.3v1.2A1.32,1.32,0,0,1,745.5,204Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M727.8,196.7c.1-1.1,1.2-3.4,3.3-3.3,2.9.2,4,2.1,3.7,3.3-.3,1-2.2.3-3.7.2C729.4,196.7,727.7,197.6,727.8,196.7Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M736.4,202.2a5.26,5.26,0,0,1,.1,3.5,11.5,11.5,0,0,1-.6,1.7c-.1.3-.3.5-.4.8a5.74,5.74,0,0,0-.4.7,2,2,0,0,0,.1,2.2,5.24,5.24,0,0,0,1,1.1,3.09,3.09,0,0,0,1.4.7,2.75,2.75,0,0,1-1.8.1,4.25,4.25,0,0,1-1.7-1,3.25,3.25,0,0,1-1-1.8,2.78,2.78,0,0,1,.4-2.2,2.1,2.1,0,0,1,.5-.7,1.61,1.61,0,0,0,.4-.7c.3-.5.5-.9.8-1.4A20.83,20.83,0,0,0,736.4,202.2Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M751.5,196.5a3.29,3.29,0,0,0-3.5-3.1c-3.1.2-4.5,1.9-4.1,3.4.3,1.2,2.5.2,4.1,0C749.8,196.5,751.5,197.7,751.5,196.5Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M739.2,219.1a17.66,17.66,0,0,1-.4-2,1.63,1.63,0,0,1,1.6-1.8,14.3,14.3,0,0,0,4.3-.9c3.8-1.4,4.3,1.2,3.2,3.8C745.1,217.6,742,218.5,739.2,219.1Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M748,218.3c-1,2.2-3.2,4.5-5.8,4a4,4,0,0,1-3-3.1C742,218.5,745.1,217.6,748,218.3Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M769.7,204.9a2.8,2.8,0,0,0-2,.3l-.3.6c-.1.2-.1.7-.2,1a15.66,15.66,0,0,1-.5,2.5,2.16,2.16,0,0,1-1.1,1.2,1.7,1.7,0,0,1-1.4,0,3.63,3.63,0,0,0,.9-.8,1.34,1.34,0,0,0,.2-.9,20.93,20.93,0,0,1,.1-2.4,7.37,7.37,0,0,1,.4-1.4,2,2,0,0,1,1.2-1.2,2.88,2.88,0,0,1,1.6,0A11.09,11.09,0,0,1,769.7,204.9Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M344.1,245.6H302.4l-4.3,2.8a2.06,2.06,0,0,1-3.2-1.7V217.2a5.38,5.38,0,0,1,5.4-5.4H344a5.38,5.38,0,0,1,5.4,5.4v23A5.23,5.23,0,0,1,344.1,245.6Z"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 308.4,
    y1: 221.3,
    x2: 336.2,
    y2: 221.3
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 308.4,
    y1: 228.9,
    x2: 336.2,
    y2: 228.9
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 308.4,
    y1: 236.5,
    x2: 324.4,
    y2: 236.5
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M446.1,412.5s16.9,8.2,37.5,29.7c22.1,23.2,27.5,37.1,24.5,50.3-2.4,10.6-2.6,4.6-24.5,6.1s-42.9,1.1-50.8.4-50.4-11.8-64.1-25-9.8-36.6,1-59.6S442.9,406.7,446.1,412.5Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M470.3,483.1s4.9-11.8,15.5-13.3,25.4,5.4,21.6,28.6c-4.5,27.5-49.3,109.3-50,112.6s5.1,11.8,10.5,16.1,26.9,13.4,22.9,22.8c0,0-24,3.4-37.8,1.7s-16.7-7.8-18.9-6.8-4.8-1.9-5.3-3.1,4.6-27.4,4.6-27.4,19.9-72.7,24.2-90.1S470.3,483.1,470.3,483.1Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M490.8,650s-24,3.4-37.8,1.7-16.7-7.8-18.9-6.8-4.8-1.9-5.3-3.1c-.2-.5.4-4.5,1.3-9.3l26.4,2.6a41.19,41.19,0,0,0,9.5,0c3.8-.4,8.1-1.7,11.3-2.2C484.9,637.6,493.5,643.7,490.8,650Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M449.8,437.7A134.22,134.22,0,0,1,475.5,460"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M436.5,474s6.9-9.3,18.3-7.8,20.3,11.4,17.3,30.2-21.8,103.9-23.3,110.8.6,13.4,5.7,22.8,14.3,16.3,13.1,23.5c0,0-4.9,1.7-18.1,1.7s-25.2-.5-26.2-1.2-3.7-5.7-5.7-6.4-4-.2-4.3-1.9,6.4-28.5,7.2-35.4C425.3,567.1,417.1,492.9,436.5,474Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M467.7,653.4s-5,1.7-18.1,1.7-25.2-.5-26.2-1.2-3.7-5.7-5.7-6.4-4-.3-4.3-1.9c-.2-.9,2-10.3,4-19.5,2.1.7,7,2.5,7.9,3.9,1.1,1.8,2.8,7.6,6.3,9.5,3.3,1.7,20-5.9,28.7-1.4C464.5,643.7,468.5,648.5,467.7,653.4Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M471.5,480.7a37.64,37.64,0,0,1,.6,15.6c-3,18.8-21.8,103.9-23.3,110.8s.6,13.4,5.7,22.8a31.73,31.73,0,0,0,3.2,4.9"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M439.4,313.2s6-1.9,20.4,21.2,13.9,21.8,13.9,21.8,39-10.5,42.7-10.4,9.8,11.9,2,18.6c-6,5.2-40.4,21.9-51.2,22-6.8,0-12.6-3.3-29.4-28.2C419.4,331.2,433.9,310.7,439.4,313.2Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M473.7,356.3s-9.2,1.8-12.2,9"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M532,338.5a37.46,37.46,0,0,0,0-6.6,59.63,59.63,0,0,0-1.8-9.6s-2.2-1.1-2.7,2.2-1.8,10.7-1.8,10.7S528.9,341.8,532,338.5Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M516.8,380.3H477.3a4,4,0,0,1-4-4.7l9.6-63.1a6.24,6.24,0,0,1,6.2-5.3h39.5a4,4,0,0,1,4,4.7L523,375A6.17,6.17,0,0,1,516.8,380.3Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M515.3,309.2H502.8a1.67,1.67,0,0,1-1.7-2h0a2.56,2.56,0,0,1,2.4-2H516a1.67,1.67,0,0,1,1.7,2h0A2.65,2.65,0,0,1,515.3,309.2Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M529.5,332.6s-14.2-.9-16.6-.6-3.1,2.5-.6,3.5c1.9.8,8.6,1.9,8.6,1.9s-13.6,2.4-15.1,3.7-.7,2.9.6,3.3c0,0-3.2,1.7-.9,3.8s10.7,2.9,10.7,2.9-7.7-1.1-7.9.9,10.2,4.2,14.3,3.7c6.1-.8,5.5-2.6,6.1-4.3s2.4-10,3.2-12.9C532,338.5,532.2,334.2,529.5,332.6Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M520.2,337.5s8,1.7,8.8,1.6"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M506.4,344.5a21.71,21.71,0,0,0,5.5.6c4,.1,15.8-1.2,15.8-1.2"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M514.3,350.9s8.1.8,11.5,0"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M439.7,334.9s9.9-12.5,4.1-33.2c-3.2-11.3-10.8-17.7-8.1-30.8,2.9-14.7,8.1-16.4-7.3-21.3,0,0-22.7-6.1-36.7,4.2-9,6.6-9.4,12.8-9.1,25.5.2,9.5-10.5.2-13.8,17.9-1.8,9.6-2.1,7.8-10.9,15.7-12.8,11.5.6,50.8,32.5,55.3S437.8,350.5,439.7,334.9Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M364.8,327.2a15.24,15.24,0,0,1,10.7-14,123,123,0,0,1,26.2-5c20.6-1.7,35.3,2,37.1,4s2.4,12.3,3.9,16.6,12.4,14.1,10.2,25.8-6.3,17.6-7.6,22.8-2.4,11.9-2.2,16,5.9,19.5,6.5,22.8-10.8,13.5-34.3,14.5c-19.4.8-39.3-5.6-46.5-10.4a4.89,4.89,0,0,1-1.9-5.6c1.9-6,6.1-20.1,6.7-24.9.7-6.3-5.4-27.8-7.4-42.9A106.37,106.37,0,0,1,364.8,327.2Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M390.2,306.6s-1.8,11.7,6.3,12.2,4.6,2.5,6.4,6.6,7.3,2.6,8,2c4.2-3.3,5.9,2.8,10,2.1s2.5-4.1,4.6-4.9,6.4,0,4.8-5.4c-1.7-5.9,4.7-1.2,1.4-8.3-3.8-8.3-22.9-7.4-34.4-4.9S390.4,304.6,390.2,306.6Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M423.6,300.3s.3,9.5.7,11.7,3.7,12.2-7,11.7c-6-.3-10.5-3.7-13.3-6.6a11.83,11.83,0,0,1-3.2-8.6l.9-16.6C401.7,291.8,421.3,289,423.6,300.3Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M408.3,297.2c.7,8.9,7.9,13,15.8,13.7-.2-1.9-.3-5.2-.4-7.7C418.7,306.7,411.9,302,408.3,297.2Z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M432.6,262.2c-13.9-2.9-29.2.3-42.4,6.1v.3c.6,22.9,8.2,35.4,21.2,37.7s22.6-5.8,21.4-20.3A214.73,214.73,0,0,1,432.6,262.2Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M390.2,268.2c13.2-5.8,28.5-9,42.4-6.1.1-2.2.2-3.4.2-3.4"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M429.8,268.2c-5.3-2.5-6.3,6.1-18.1,2.1-3.1-1.1-6.5-4.6-7.3,3-.4,3.6,1.1,7.1-3.7,13.9-3.9,5.6,10.5,22.7-8.9,29.4-13.3,4.6-20.3-5.2-27.8,6.4-5,7.7,4.5-15.9,22.3-27,8.4-5.2,1.5-21.5,1-25.3s1.7-11.5,14.4-14.5,26.6-13.8,35.5-5C443.4,257.3,442.2,273.9,429.8,268.2Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M380.7,319.8a10.66,10.66,0,0,0-16.8,3.3c-3.4,7.2-9.1,19.4-14.7,32.7-8.9,21.3-12.6,41.8,0,48.5s29.7-6.7,38.6-17.3S409,360,409,360s-1.9-12.9-11-13.6l-17.1,12.9s4-9.2,5.4-13.9,1.2-19.1-5.4-25.5A.35.35,0,0,1,380.7,319.8Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M380.9,359.3s-24,15.1-28.2,23"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M397.9,346.4s16-10.5,17.3-11,11.1,1.7,12.1,2.2,3,5.3,3,5.3,8,3.8,8.2,4.5-1.4,2.8-1.9,3.1-2.7.4-3.1.5-4.5,6.7-6.5,8.3-11.5.2-12.9.2-7.9,2-7.9,2-4.2-.9-7.3-6S397.9,346.4,397.9,346.4Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M445.9,345.1l2.8,2a.49.49,0,0,1-.3.9l-3.4.1-35.6-10.6a1.76,1.76,0,0,1-1.4-2.1h0a1.78,1.78,0,0,1,2.3-1Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M429.8,343.7s7.3-.5,7.7-1.3a2.43,2.43,0,0,0-.9-3c-1.1-.9-12.7-1.4-15.2-1.6a11.8,11.8,0,0,0-8,2.2C411.3,342,422.6,349,429.8,343.7Z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M433.6,351s-5.5-.8-6.2-.8h-3"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M430.4,355.4s-3.8.3-5.2.5a14,14,0,0,1-2.3,0"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M419.5,294.9a9.14,9.14,0,0,1-6.6-2.9"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M428.3,284.6h0a1.75,1.75,0,0,0,1.7-1.7v-1a1.75,1.75,0,0,0-1.7-1.7h0a1.75,1.75,0,0,0-1.7,1.7v1A1.69,1.69,0,0,0,428.3,284.6Z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M412.7,284.6h0a1.75,1.75,0,0,0,1.7-1.7v-1a1.75,1.75,0,0,0-1.7-1.7h0a1.75,1.75,0,0,0-1.7,1.7v1A1.75,1.75,0,0,0,412.7,284.6Z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M422.6,291.3a4.23,4.23,0,0,0,2.1-1.5,3.15,3.15,0,0,0,.8-1.9.9.9,0,0,0-.1-.5l-.2-.7c-.1-.5-.2-.9-.3-1.5a9.42,9.42,0,0,1,.1-2.9,15.77,15.77,0,0,1,1.3,2.6l.5,1.2.3.7a2.92,2.92,0,0,1,.2.9,3.74,3.74,0,0,1-.5,1.8,3.45,3.45,0,0,1-1.2,1.2,4.71,4.71,0,0,1-1.5.6A1.36,1.36,0,0,1,422.6,291.3Z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M407.9,274.2c.1-1,1.3-1.6,3.2-2.1,4-.5,5.6,1.1,5,3.1-.5,1.6-3.3.1-5.1.1C409.5,275.2,407.9,275.1,407.9,274.2Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M432.1,274.1c0-1-1-1.5-2.4-2.1-3-.6-4.3,1-3.9,2.8.4,1.5,2.5.2,3.9.2C430.9,275.1,432.2,275,432.1,274.1Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M287.5,286.9a64,64,0,0,0,.9,13,4.12,4.12,0,0,1-2.5,4.6,4.48,4.48,0,0,1-3.9-.2C278.8,302.3,283.8,281,287.5,286.9Z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M242.4,294.8s.1,7,.7,11.5a4.17,4.17,0,0,0,5.1,3.5,4.88,4.88,0,0,0,.7-.3c1.8-1.2.5-17.6.5-17.6S242.8,292,242.4,294.8Z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M238.1,280a49.55,49.55,0,0,1-4.8,19.7,2.77,2.77,0,0,0,.7,3.2h.1a2.65,2.65,0,0,0,4.1-.9c2-4,5.8-12.8,5.5-22.1C243.4,267.4,238.1,280,238.1,280Z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M280.3,654c.1,1.5-2.5,4.3-7.7,4.3H251.8c-18.2,0-24.7-.9-24-6.5a27,27,0,0,0-.5-9.8s-2.2-1.1-2.6-2,0-1.9,1.7-10.4c.1-.5.2-1.1.3-1.7,1.5-8.8,2.8-23,2.8-23,3.9-1.9,31.4,3.3,31.4,3.3s-2.5,10.6-1.2,15.7a6.37,6.37,0,0,0,.2.7C261.5,629.5,280.2,652.6,280.3,654Z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M259.3,620.7a60.81,60.81,0,0,1,1.6-12.5s-27.5-5.2-31.4-3.3c0,0-.3,3.2-.8,7.6C237.1,620.3,248.5,622.2,259.3,620.7Z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M270.1,639.9c-6.3-3.1-18.2-3.4-28.2-.7a4,4,0,0,1-5-2.9,59.15,59.15,0,0,1-2-8.5c-.4-3.3-4.5-2.7-7.3-5.8-.4,2.7-.8,5.4-1.2,7.5-1.7,8.5-2,9.5-1.7,10.4s2.6,2,2.6,2a30.37,30.37,0,0,1,.5,9.8c-.7,5.6,5.8,6.5,24,6.5h20.8c5.2,0,7.8-2.8,7.7-4.3C280.2,653.3,275.2,646.7,270.1,639.9Z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M326.4,604.9s-.2,16.1-1.3,24.7-1.3,9.5-.9,10.4,2.8,2,2.8,2a28.18,28.18,0,0,1,1.2,9.8c-.3,5.6,6.3,6.5,24.5,6.5h20.8c5.2,0,7.6-2.8,7.4-4.3s-20.7-24.5-22.7-29.4-.2-16.5-.2-16.5S330.2,603,326.4,604.9Z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M357.3,616.5a75.23,75.23,0,0,1,.7-8.3s-27.9-5.2-31.6-3.3c0,0-.1,5.1-.3,11C335.3,622.3,346.9,620,357.3,616.5Z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M368.6,638.6c-10.7-2-22.4,3-32.1-1.4-2.3-.6-3.3-5.4-4.9-8.4-1.3-2.5-3.1-3.3-6-4.7-.1,2-.3,3.9-.5,5.5-1,8.5-1.3,9.5-.9,10.4s2.8,2,2.8,2a28.18,28.18,0,0,1,1.2,9.8c-.3,5.6,6.3,6.5,24.5,6.5h20.8c5.2,0,7.6-2.8,7.4-4.3C380.8,653.2,374.6,645.9,368.6,638.6Z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M215,415.1s-8.2,8.4-8.3,27.8c-.1,23.1,14.6,39.7,38.7,39.7s72-.7,89.1,0,14.8-37,2.2-48.6S226.5,401,215,415.1Z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M238.4,473.4c2.4-7.5,10.9-19.5,26.4-16.4,16.8,3.3,25,9,17.1,57.9-6.9,42.4-19.2,90.7-21.1,97.8a2,2,0,0,1-1.2,1.3,37,37,0,0,1-12.2,1.9c-7.4,0-15.5-2.7-18.7-5.5a3,3,0,0,1-1-2.5c.8-12,6.8-104.1,7.3-111C236,487,236.7,478.7,238.4,473.4Z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M350.4,457c17.2.7,26.3,11.9,21.5,57.9-4.3,41.2-12,88.3-13.4,97.2a2.6,2.6,0,0,1-1.8,2.1,35.37,35.37,0,0,1-11.4,1.6c-7,0-14.9-2.4-18.6-5.1a3.87,3.87,0,0,1-1.6-3.4c.3-10.7,1.5-67.3-2.5-110.3C320,469.6,334.3,456.3,350.4,457Z"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 267,
    cy: 473.5,
    rx: 13.9,
    ry: 11.6
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 352,
    cy: 473.5,
    rx: 13.9,
    ry: 11.6
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M331.6,370.9c-.6-1.6-1-2.6-1-2.6L298.5,375l.6,15.9C311.4,387.5,322.6,380.1,331.6,370.9Z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M340.1,396.2c-1.7-7.3-6.4-19.9-8.5-25.3-9,9.3-20.2,16.6-32.6,19.9l.5,15.3,14.2,44.4,16.8-9.6C343.1,413.4,342.3,405.6,340.1,396.2Z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M186.4,374.7a2.91,2.91,0,0,1-1.6-3.8c3.1-8.8,13.8-37.5,22.8-47.5,10.8-11.9,44.9-12.6,59.4-12.6s34.9,2.6,43,9.6c7,6,18.6,35.8,21.8,44.2a3.13,3.13,0,0,1-1.1,3.6c-4,2.7-13.5,8.8-22.5,12.1l4.3,60.6s-93.4-1.4-97.1-3.2-8.5-23.7-7.8-26,7.4-27.8,7.4-27.8S196.2,379,186.4,374.7Z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 296.99,
    cy: 274.19,
    rx: 6,
    ry: 2.9,
    transform: "translate(-91.3 161.89) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 317.2,
    cy: 287.89,
    rx: 6,
    ry: 2.9,
    transform: "translate(-95.3 172.38) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 272.39,
    cy: 286.49,
    rx: 6,
    ry: 2.9,
    transform: "translate(-99.41 152.18) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 292.6,
    cy: 300.19,
    rx: 6,
    ry: 2.9,
    transform: "translate(-103.4 162.67) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 315.5,
    cy: 311.32,
    rx: 6,
    ry: 2.9,
    transform: "translate(-105.96 174.09) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 335.71,
    cy: 325.02,
    rx: 6,
    ry: 2.9,
    transform: "translate(-109.95 184.59) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 290.99,
    cy: 323.58,
    rx: 6,
    ry: 2.9,
    transform: "translate(-114.04 164.42) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 311.2,
    cy: 337.28,
    rx: 6,
    ry: 2.9,
    transform: "translate(-118.03 174.91) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 247.79,
    cy: 298.8,
    rx: 6,
    ry: 2.9,
    transform: "translate(-107.52 142.47) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 268,
    cy: 312.5,
    rx: 6,
    ry: 2.9,
    transform: "translate(-111.51 152.96) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 223.19,
    cy: 311.11,
    rx: 6,
    ry: 2.9,
    transform: "translate(-115.62 132.76) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 243.4,
    cy: 324.8,
    rx: 6,
    ry: 2.9,
    transform: "translate(-119.62 143.26) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 266.39,
    cy: 335.88,
    rx: 6,
    ry: 2.9,
    transform: "translate(-122.15 154.71) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 286.6,
    cy: 349.58,
    rx: 6,
    ry: 2.9,
    transform: "translate(-126.14 165.21) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 241.79,
    cy: 348.19,
    rx: 6,
    ry: 2.9,
    transform: "translate(-130.25 145.01) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 262,
    cy: 361.89,
    rx: 6,
    ry: 2.9,
    transform: "translate(-134.25 155.5) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 334.61,
    cy: 349.39,
    rx: 6,
    ry: 2.9,
    transform: "translate(-120.98 186.67) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 354.82,
    cy: 363.09,
    rx: 6,
    ry: 2.9,
    transform: "translate(-124.97 197.16) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 310.01,
    cy: 361.69,
    rx: 6,
    ry: 2.9,
    transform: "translate(-129.08 176.96) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 330.22,
    cy: 375.39,
    rx: 6,
    ry: 2.9,
    transform: "translate(-133.08 187.46) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 353.12,
    cy: 386.52,
    rx: 6,
    ry: 2.9,
    transform: "translate(-135.63 198.88) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 373.42,
    cy: 400.17,
    rx: 6,
    ry: 2.9,
    transform: "translate(-139.6 209.41) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 328.61,
    cy: 398.78,
    rx: 6,
    ry: 2.9,
    transform: "translate(-143.71 189.21) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 348.82,
    cy: 412.48,
    rx: 6,
    ry: 2.9,
    transform: "translate(-147.71 199.7) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 285.41,
    cy: 374,
    rx: 6,
    ry: 2.9,
    transform: "translate(-137.19 167.26) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 305.62,
    cy: 387.7,
    rx: 6,
    ry: 2.9,
    transform: "translate(-141.18 177.75) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 260.81,
    cy: 386.3,
    rx: 6,
    ry: 2.9,
    transform: "translate(-145.3 157.55) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 281.02,
    cy: 400,
    rx: 6,
    ry: 2.9,
    transform: "translate(-149.29 168.04) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 304.01,
    cy: 411.08,
    rx: 6,
    ry: 2.9,
    transform: "translate(-151.82 179.5) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 324.22,
    cy: 424.78,
    rx: 6,
    ry: 2.9,
    transform: "translate(-155.81 189.99) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 279.41,
    cy: 423.39,
    rx: 6,
    ry: 2.9,
    transform: "translate(-159.93 169.79) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 299.62,
    cy: 437.09,
    rx: 6,
    ry: 2.9,
    transform: "translate(-163.92 180.28) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 198.42,
    cy: 323.59,
    rx: 6,
    ry: 2.9,
    transform: "translate(-123.83 123) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 218.59,
    cy: 337.2,
    rx: 6,
    ry: 2.9,
    transform: "translate(-127.79 133.46) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 173.82,
    cy: 335.89,
    rx: 6,
    ry: 2.9,
    transform: "translate(-131.93 113.29) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 194.03,
    cy: 349.59,
    rx: 6,
    ry: 2.9,
    transform: "translate(-135.93 123.78) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 216.93,
    cy: 360.71,
    rx: 6,
    ry: 2.9,
    transform: "translate(-138.49 135.21) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 237.09,
    cy: 374.32,
    rx: 6,
    ry: 2.9,
    transform: "translate(-142.44 145.67) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 192.42,
    cy: 372.98,
    rx: 6,
    ry: 2.9,
    transform: "translate(-146.56 125.53) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 212.63,
    cy: 386.67,
    rx: 6,
    ry: 2.9,
    transform: "translate(-150.56 136.03) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 149.22,
    cy: 348.2,
    rx: 6,
    ry: 2.9,
    transform: "translate(-140.04 103.58) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 169.43,
    cy: 361.9,
    rx: 6,
    ry: 2.9,
    transform: "translate(-144.04 114.08) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 124.62,
    cy: 360.5,
    rx: 6,
    ry: 2.9,
    transform: "translate(-148.15 93.88) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 144.83,
    cy: 374.2,
    rx: 6,
    ry: 2.9,
    transform: "translate(-152.14 104.37) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 167.82,
    cy: 385.28,
    rx: 6,
    ry: 2.9,
    transform: "translate(-154.67 115.83) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 188.03,
    cy: 398.98,
    rx: 6,
    ry: 2.9,
    transform: "translate(-158.66 126.32) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 143.22,
    cy: 397.59,
    rx: 6,
    ry: 2.9,
    transform: "translate(-162.78 106.12) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 163.43,
    cy: 411.29,
    rx: 6,
    ry: 2.9,
    transform: "translate(-166.77 116.61) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 236,
    cy: 398.69,
    rx: 6,
    ry: 2.9,
    transform: "translate(-153.46 147.76) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 256.21,
    cy: 412.39,
    rx: 6,
    ry: 2.9,
    transform: "translate(-157.46 158.25) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 211.4,
    cy: 411,
    rx: 6,
    ry: 2.9,
    transform: "translate(-161.57 138.05) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 231.61,
    cy: 424.7,
    rx: 6,
    ry: 2.9,
    transform: "translate(-165.57 148.54) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 254.6,
    cy: 435.78,
    rx: 6,
    ry: 2.9,
    transform: "translate(-168.09 160) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 274.8,
    cy: 449.48,
    rx: 6,
    ry: 2.9,
    transform: "translate(-172.09 170.49) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 229.99,
    cy: 448.08,
    rx: 6,
    ry: 2.9,
    transform: "translate(-176.2 150.29) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 250.2,
    cy: 461.78,
    rx: 6,
    ry: 2.9,
    transform: "translate(-180.19 160.78) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 186.8,
    cy: 423.31,
    rx: 6,
    ry: 2.9,
    transform: "translate(-169.68 128.34) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 207.01,
    cy: 437,
    rx: 6,
    ry: 2.9,
    transform: "translate(-173.67 138.83) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 162.2,
    cy: 435.61,
    rx: 6,
    ry: 2.9,
    transform: "translate(-177.79 118.63) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 182.41,
    cy: 449.31,
    rx: 6,
    ry: 2.9,
    transform: "translate(-181.78 129.12) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 205.39,
    cy: 460.39,
    rx: 6,
    ry: 2.9,
    transform: "translate(-184.31 140.58) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 225.6,
    cy: 474.09,
    rx: 6,
    ry: 2.9,
    transform: "translate(-188.3 151.07) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 180.79,
    cy: 472.7,
    rx: 6,
    ry: 2.9,
    transform: "translate(-192.42 130.87) rotate(-26.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 201,
    cy: 486.39,
    rx: 6,
    ry: 2.9,
    transform: "translate(-196.41 141.37) rotate(-26.58)"
  }))), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M215,383.9s3.7,1,5.2,1.3c0,0,8.2-23.2,9.3-29.7s1.1-11.3,0-13.5"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M308.2,380.3s-.9-27.2-1.3-32.8-.6-10.4-2.4-14.1"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M215,383.9s-20-5.4-28.2-9c0,0-.3.8-.7,2.1,8.3,6.1,17.3,11.6,27,13.9Z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M262.5,434c-3-.3-13.2,2.2-13.2,2.2-10-10.2-38.8-35.2-38.8-35.2l2.7-10.2c-9.7-2.3-18.7-7.8-27-13.9-2,6-7.5,23.8-6,32.9,1.9,11.1,32.8,30.9,57.3,43.5,0,0,3.3,3.6,11.5,6.1,2.7.8,6.4,2.1,7.9,2.3s5.4-.2,7.8,0,3.5-1.9,6.1-1.6,3.3-1.4,5.2-.3,3.3-1.1,3.3-3.3S265.5,434.4,262.5,434Z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M210.5,401.1s-7.2-2.8-12.9,0"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M283.7,318.5c.4,9.6-7.9,17.2-18.4,16.9s-19.4-8.4-19.7-18,8.7-12.6,19.3-12.3S283.4,308.9,283.7,318.5Z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M250.5,293.5s.2,19.9,0,23.6,4.1,12.8,16.6,12.8,13.1-12.2,12.9-12.8-.7-19.4-1.3-20.6C278.3,295.3,254.1,288.7,250.5,293.5Z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M257.7,309.4c5.9,6.7,14.1,9.2,22.3,8.8a3.59,3.59,0,0,0,0-1.1c0-.2-.1-1.7-.2-3.9C272.4,315.5,265.1,311.5,257.7,309.4Z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M284.4,294.8a41.23,41.23,0,0,0,6-17.4c1.4-11.6-4.1-19.7-11.6-23.3-5.2-2.5-23.9-6.8-35.5,4.5-7.3,7.1-8.3,30.2,3.1,35.7,14.6,7,2.2,8.5,2.8,9.1,0,0,.3,1.7,4.5-2.8S284.4,294.8,284.4,294.8Z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M287.5,280.5s-.8,13.2-1.4,21.1-4.6,16-18.1,16.4-19.9-9.9-21.4-17.6c-2.2-11.7-6-34.3,12.7-36.9S287.5,266.8,287.5,280.5Z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M287.5,272.4s-11.6,13.4-29.1,2.8c-6.4-3.9-7.9,1.9-7.9,4.2,0,3.2,1.5,9.5-3.5,12.1-2,1-5.1-5.2-3.4-19.1s28-12.8,36.7-11.8S288.9,266.2,287.5,272.4Z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M249,290.1s-2-8.3-7.5-6.6-3.1,15.2,5.9,16.9"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M268.8,308.4a9.51,9.51,0,0,1-6.9-3"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M279.8,293.4h0a1.79,1.79,0,0,0,1.8-1.8v-1a1.79,1.79,0,0,0-1.8-1.8h0a1.79,1.79,0,0,0-1.8,1.8v1A1.86,1.86,0,0,0,279.8,293.4Z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M262.3,293.4h0a1.79,1.79,0,0,0,1.8-1.8v-1a1.79,1.79,0,0,0-1.8-1.8h0a1.79,1.79,0,0,0-1.8,1.8v1A1.79,1.79,0,0,0,262.3,293.4Z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M283.4,284.2a3.25,3.25,0,0,0-3.6-2.7c-3.1.1-3.6,1.9-3.2,3.1.3,1,1.7-.1,3.3-.3C281.7,284.2,283.5,285.2,283.4,284.2Z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M270.7,304.2a3.94,3.94,0,0,0,3.4-1.7,4.84,4.84,0,0,0,.7-1.8,12,12,0,0,0,.3-2,30.24,30.24,0,0,0-.2-4.2,17,17,0,0,1,0-4.5c.5,1.4,1,2.8,1.4,4.2a17.42,17.42,0,0,1,.5,2.2,9.06,9.06,0,0,1,.1,2.3,6.81,6.81,0,0,1-1.7,4.5,4,4,0,0,1-2.2,1.2A3.6,3.6,0,0,1,270.7,304.2Z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M257.7,284.2c.1-1.2,1.4-2.8,3.8-2.7,3.4.2,3.9,1.9,3.5,3.1-.4,1-1.8-.1-3.5-.3C259.5,284.2,257.6,285.2,257.7,284.2Z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M241.6,289.1a2.13,2.13,0,0,1,.7-1.2.94.94,0,0,1,.9-.1.52.52,0,0,1,.4.2c.1.1.3.2.3.3a4.18,4.18,0,0,1,.8,1.2,6.33,6.33,0,0,1,.4,3.7,2.72,2.72,0,0,0,0,.9c.1.3.4.5.7.8a1.81,1.81,0,0,1-1.4-.2,2.58,2.58,0,0,1-.8-1.3c-.2-.9-.3-1.6-.4-2.3-.1-.3-.1-.7-.2-1l-.3-.9c-.1-.2-.1-.4-.4-.4C242.4,288.7,242,288.9,241.6,289.1Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-27",
    cx: 260.6,
    cy: 291.8,
    r: 8.5
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-27",
    cx: 283.5,
    cy: 291.8,
    rx: 7.7,
    ry: 8.5
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M252.6,288.9h-1.4a2.72,2.72,0,0,1-1.7-.6l-1.7-1.4"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M268.9,290s4.7-1.7,6.9,0"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M353.4,466h-96a4.25,4.25,0,0,1-4.1-5.4l7.2-26.5,7.3-27a6.84,6.84,0,0,1,6.6-5.1h96a4.25,4.25,0,0,1,4.1,5.4L360,460.9A6.84,6.84,0,0,1,353.4,466Z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M374.5,407.5,360,460.9a6.84,6.84,0,0,1-6.6,5.1h-96"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 317.49,
    cy: 434.82,
    rx: 8,
    ry: 6.2,
    transform: "translate(-208 317.64) rotate(-41.29)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M238.1,271.2a33.4,33.4,0,0,1-7.3,14.6,2.83,2.83,0,0,0,.4,4.2h0a2.89,2.89,0,0,0,4.1-.5,59.53,59.53,0,0,0,8.6-14.3C245.9,270,238.6,269.3,238.1,271.2Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamwork);
export default __webpack_public_path__ + "static/media/teamwork.69b28122c2f4889beb459ddec7bc7fee.svg";
export { ForwardRef as ReactComponent };